import ConsultantSearchCard from './ConsultantSearchCard';
export default ConsultantSearchCard;